import React from 'react'
import { Grid, ThemeProvider, Typography } from '@mui/material'
import Condition from 'components/Condition'
import PagePlaceholder from 'components/PagePlaceholder'
import { graphql } from 'relay-runtime'
import { useFragment } from 'react-relay'
import landingTheme from 'scenes/Landing/landingTheme'
import LandingHeader, { LandingHeaderSubtitle, LandingHeaderTitle } from 'scenes/Landing/components/LandingHeader'
import { BlogSubcategoryLanding_Query$key } from '__generated__/BlogSubcategoryLanding_Query.graphql'
import Page from 'components/Page'
import PageBody from 'components/PageBody'
import PageContent from 'components/PageContent'
import { makeStyles } from 'tss-react/mui'
import BlogPostItem from '../BlogPostItem'

const useStyles = makeStyles()(theme => ({
  container: {
    paddingTop: theme.spacing(6),
  },
}))

export interface IBlogSubcategoryLandingProps {
  queryFragmentRef: BlogSubcategoryLanding_Query$key
}

function BlogSubcategoryLanding(props: IBlogSubcategoryLandingProps) {
  const { queryFragmentRef } = props
  const { classes } = useStyles()

  const data = useFragment(
    graphql`
      fragment BlogSubcategoryLanding_Query on Query
      @argumentDefinitions(
        subcategory: { type: "String!" }
      )
      {
        blogPosts(last: 20, subcategorySlug: $subcategory) {
          nodes {
            id
            ...BlogPostItem_BlogPost
          }
        }
        blogSubcategory(slug: $subcategory) {
          name
          slug
          description
          heroImageUrl
          blogCategory {
            name
            slug
          }
        }
      }
    `,
    queryFragmentRef,
  )

  const blogSubcategory = data?.blogSubcategory
  const blogPosts = data?.blogPosts

  if (!blogSubcategory) {
    return (
      <PagePlaceholder title="Not Found" />
    )
  }

  return (
    <Page>
      <ThemeProvider theme={landingTheme}>
        <LandingHeader backgroundImage={blogSubcategory.heroImageUrl}>
          <LandingHeaderTitle>
            {blogSubcategory.blogCategory?.name} / {blogSubcategory.name}
          </LandingHeaderTitle>

          <Condition condition={Boolean(blogSubcategory.description)}>
            <LandingHeaderSubtitle style={{ maxWidth: 700, marginLeft: 'auto', marginRight: 'auto' }}>
              {blogSubcategory.description}
            </LandingHeaderSubtitle>
          </Condition>
        </LandingHeader>

        <PageBody>
          <PageContent>
            <div className={classes.container}>
              <Grid container spacing={4}>
                {blogPosts.nodes.length === 0 && (
                  <Grid item xs={12} md={12} lg={12}>
                    <Typography variant="h2">
                      No posts to show
                    </Typography>
                  </Grid>
                )}

                {blogPosts.nodes.map(blogPost => (
                  <Grid key={blogPost.id} item xs={12} md={4} lg={4}>
                    <BlogPostItem blogPostFragmentRef={blogPost} variant="outlined" />
                  </Grid>
                ))}
              </Grid>
            </div>
          </PageContent>
        </PageBody>
      </ThemeProvider>
    </Page>
  )
}

export default React.memo(BlogSubcategoryLanding)
